// Computes the indentation level for a given key,
// which corresponds to its level in the hierarchy.
// Applies to both regions and religions.
export function indentation(key) {
  for(let i = 0; i < key.length; i++) {
    if (key.charAt(i) !== ' ') {
      return i / 2;
    }
  }
  throw new Error('this should never happen');
};



// WEBPACK FOOTER //
// ./src/Sankey/indentation.js